import React, { useState, useEffect } from 'react'
import { ButtonToolbar, Checkbox, Icon, Row, Table } from 'rsuite'
import { Controller, useForm } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { cloneDeep } from 'lodash-es'

export default function DataImportUserRoleTable({
  schema,
  loading,
  onCancel = () => {},
  onSave = () => {},
}) {
  const { control } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [checkedKeys, setCheckedKeys] = useState([])
  const [indeterminate, setIndeterminate] = useState(false)
  const [countSelected, setCountSelected] = useState(0)

  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    setTableData(schema)
  }, [schema])

  const autoCheckAll = () => {
    let checkedKeys

    checkedKeys = tableData?.map((item) => item.id)
    //checkedKeys = tableData?.filter((e) => !e.isDupplicate)?.map((item) => item.projectCode)
    setIndeterminate(false)
    setCheckedKeys(checkedKeys)
    setCountSelected(checkedKeys.length)
  }

  const handleCheckAll = (value, checked) => {
    let checkedKeys
    // checkedKeys = checked
    // ? tableData?.filter((e) => !e.isDupplicate)?.map((item) => item.projectCode)
    //   : []
    checkedKeys = checked ? tableData?.map((item) => item.id) : []
    setIndeterminate(false)
    setCheckedKeys(checkedKeys)
    setCountSelected(checkedKeys.length)
  }

  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value)

    let allCount = tableData?.length //tableData?.filter((e) => !e.isDupplicate).length

    if (nextCheckedKeys.length != allCount) {
      setIndeterminate(true)
    } else {
      setIndeterminate(false)
    }
    setCheckedKeys(nextCheckedKeys)
    setCountSelected(nextCheckedKeys.length)
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => {
    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey])}
            style={{ marginLeft: -30 }}
            //disabled={type == 'imp03' && rowData.isDupplicate}
          />
          {/* <b
            style={{
              color: rowData.isDupplicate ? '#fb8a81' : '',
            }}
          > */}
          {props.rowIndex + 1}
          {/* </b> */}
        </div>
      </Cell>
    )
  }

  const handleSave = () => {
    var data = cloneDeep(tableData)
    let newArr = []
    data.map((item) => {
      if (checkedKeys.includes(item.id)) {
        if (item.id?.includes('dummy')) {
          item.id = null
        }
        newArr.push(item)
      }
    })
    // console.log('ggggg ', newArr)
    onSave(newArr)
  }

  return (
    <>
      <Table
        wordWrap
        height={800}
        autoHeight={tableData?.length < 10}
        headerHeight={fs <= 18 ? 40 : 50}
        loading={loading}
        data={tableData || []}
        style={{ marginTop: '20px' }}
        // affixHeader
        // rowClassName={(rowData) => {
        //   console.log('ggggg => ', rowData)
        //   if (rowData?.isDupplicate) {
        //     return 'karya-table-row'
        //   }
        // }}
        onDataUpdated={() => {
          autoCheckAll()
        }}
      >
        <Column width={100} align="center">
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: '40px' }}>
              <Controller
                name="chkRow"
                control={control}
                render={(props) => {
                  // if (isEditMode) {
                  //   return 'ลำดับ'
                  // }
                  return (
                    <Checkbox
                      inline
                      checked={props.value}
                      indeterminate={indeterminate}
                      onChange={(e, checked) => {
                        props.onChange(checked)
                        handleCheckAll(null, checked)
                      }}
                      style={{ marginLeft: -10 }}
                    >
                      <b>ลำดับ</b>
                    </Checkbox>
                  )
                }}
              />
            </div>
          </HeaderCell>

          <CheckCell
            dataKey="id"
            checkedKeys={checkedKeys}
            onChange={(value, checked) => {
              handleCheck(value, checked)
            }}
          />
        </Column>

        <Column width={180}>
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>

        <Column width={120}>
          <HeaderCell>คำนำหน้า</HeaderCell>
          <Cell dataKey="preName" />
        </Column>

        <Column width={180}>
          <HeaderCell>ชื่อ</HeaderCell>
          <Cell dataKey="firstName" />
        </Column>

        <Column width={180}>
          <HeaderCell>สกุล</HeaderCell>
          <Cell dataKey="lastName" />
        </Column>

        <Column width={180}>
          <HeaderCell>เบอร์โทร</HeaderCell>
          <Cell dataKey="mobileNumber" />
        </Column>

        <Column width={200}>
          <HeaderCell>e-mail</HeaderCell>
          <Cell dataKey="email" />
        </Column>

        <Column width={200}>
          <HeaderCell>ประเภทการใช้งาน</HeaderCell>
          <Cell dataKey="authType" />
        </Column>

        <Column width={200} align="center" fixed="right">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData, index) => {
              return (
                <p style={{ color: rowData.isExist ? '#fb8a81' : '' }}>
                  {rowData.isExist ? (
                    <span>
                      {/* <Icon
                        icon="exclamation-circle2"
                        style={{ color: rowData.isDupplicate ? '#fb8a81' : '', marginRight: 10 }}
                      /> */}
                      รายการนี้มีข้อมูลอยู่แล้ว
                    </span>
                  ) : (
                    ''
                  )}
                </p>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <Row style={{ marginTop: 20 }}>
        {/* <hr /> */}
        <ButtonToolbar style={{ textAlign: 'right' }}>
          <SaveButton
            disabled={countSelected == 0}
            onClick={() => {
              handleSave()
            }}
          >
            {`บันทึก ${countSelected} รายการ`}
          </SaveButton>

          <CancelButton
            onClick={() => {
              onCancel()
            }}
          >
            {'ยกเลิก'}
          </CancelButton>
        </ButtonToolbar>
      </Row>
    </>
  )
}
